import { useEffect, useState } from 'react';

const BRANCH_BASE_URL = 'https://branch.wallet.bitcoin.com/';

const getOSLink = ({ android = '', iOS = '', fallback = '' }) => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  const userAgent = window.navigator.userAgent || window.opera;

  if (/android/i.test(userAgent)) {
    return android;
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return iOS;
  }

  return fallback;
};

export const useBranchLink = ({
  branch = '',
  android = '',
  iOS = '',
  fallback = '',
}) => {
  const [link, setLink] = useState(branch);
  const [tested, setTested] = useState(false);

  useEffect(() => {
    const testBranch = async () => {
      try {
        const branchResponse = await fetch(BRANCH_BASE_URL, {
          redirect: 'manual',
        });
        if (branchResponse.type !== 'opaqueredirect' && !branchResponse.ok) {
          const osLink = getOSLink({ android, iOS, fallback });
          setLink(osLink);
        }
      } catch (e) {
        const osLink = getOSLink({ android, iOS, fallback });
        setLink(osLink);
      }

      setTested(true);
    };

    if (!tested) {
      testBranch();
    }
  }, [branch, android, iOS, fallback, tested]);

  return link;
};
